// extracted by css-extract-rspack-plugin
export default {"logo":"Layout_logo__TP8Nx"};